import { render, staticRenderFns } from "./FormApproveSR.vue?vue&type=template&id=718b5c77&scoped=true"
import script from "./FormApproveSR.vue?vue&type=script&lang=js"
export * from "./FormApproveSR.vue?vue&type=script&lang=js"
import style0 from "./FormApproveSR.vue?vue&type=style&index=0&id=718b5c77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b5c77",
  null
  
)

export default component.exports